(function () {
  var BUTTON_SELECTOR =
    '.button, .shopify-challenge__button, .customer button, .shopify-payment-button__button--unbranded';

  function createRipple(event) {
    var button = event.target.closest(BUTTON_SELECTOR);
    if (!button || button.disabled) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var container = button.querySelector(':scope > .button__ripple-container');
    if (!container) {
      container = document.createElement('span');
      container.className = 'button__ripple-container';
      button.appendChild(container);
    }

    var rect = button.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height);
    // event.clientX/Y is 0 for keyboard-triggered clicks (Enter/Space),
    // so fall back to the button's center in that case.
    var originX = event.clientX || rect.left + rect.width / 2;
    var originY = event.clientY || rect.top + rect.height / 2;

    var ripple = document.createElement('span');
    ripple.className = 'button__ripple';
    ripple.style.width = size + 'px';
    ripple.style.height = size + 'px';
    ripple.style.left = originX - rect.left - size / 2 + 'px';
    ripple.style.top = originY - rect.top - size / 2 + 'px';

    container.appendChild(ripple);
    ripple.addEventListener('animationend', function () {
      ripple.remove();
    });
  }

  document.addEventListener('click', createRipple);
})();